export enum RejectedDocumentTypeEnum {
  VERIFICATION_VIDEO = 'verification_video',
  PHOTOGRAPH = 'photograph',
  KENYAN_ID_PROOF = 'kenyan_id_proof',
  KRA_PIN = 'KRA_pin',
  DOCUMENT = 'registration_document'
}
